import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import phone from '@galo-monitor/forms/validators/phone.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const userProfileSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  email: required({ t })(Yup.string()),
  phone: flow(
    phone({ t }),
    required({ t })
  )(Yup.string()),
  language: required({ t })(Yup.string())
})

export default userProfileSchema
